<template>
    <v-form ref="formRef" class="pb-4" data-cy="description-general-form">
        <v-row dense class="mb-4">
            <v-col cols="12" sm="6" md="2">
                <LocaleSwitcher @change="changeActiveLangCode" />
            </v-col>
        </v-row>
        <!--        TODO [P2] Revert in v10.4-->
        <!--        <v-row dense>-->
        <!--            <v-col cols="12" md="2">-->
        <!--                <div class="text-h6 text&#45;&#45;secondary">TripAdvisor</div>-->
        <!--                <img :src="$filters.srcHost('/tripadvisor/ta.svg')" alt="Tripadvisor" height="20" />-->
        <!--            </v-col>-->
        <!--            <v-col cols="12" md="4">-->
        <!--                <v-row dense>-->
        <!--                    <v-col cols="12" sm="4">-->
        <!--                        <v-text-field-->
        <!--                            :label="$t('rating')"-->
        <!--                            type="number"-->
        <!--                            hide-spin-buttons-->
        <!--                            variant="outlined"-->
        <!--                            color="primary"-->
        <!--                            density="compact"-->
        <!--                            data-cy="rating"-->
        <!--                            :readonly="-->
        <!--                                isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription-->
        <!--                            "-->
        <!--                            disabled-->
        <!--                        />-->
        <!--                    </v-col>-->
        <!--                    <v-col cols="12" sm="4">-->
        <!--                        <v-text-field-->
        <!--                            :label="$t('quantity_of_reviews')"-->
        <!--                            type="number"-->
        <!--                            hide-spin-buttons-->
        <!--                            variant="outlined"-->
        <!--                            color="primary"-->
        <!--                            density="compact"-->
        <!--                            data-cy="quantity-of-reviews"-->
        <!--                            :readonly="-->
        <!--                                isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription-->
        <!--                            "-->
        <!--                            disabled-->
        <!--                        />-->
        <!--                    </v-col>-->
        <!--                    <v-col cols="12" sm="4">-->
        <!--                        <v-text-field-->
        <!--                            :label="`TripAdvisor ${$t('id')}`"-->
        <!--                            variant="outlined"-->
        <!--                            color="primary"-->
        <!--                            density="compact"-->
        <!--                            data-cy="TripAdvisor-id"-->
        <!--                            :readonly="-->
        <!--                                isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription-->
        <!--                            "-->
        <!--                            disabled-->
        <!--                        />-->
        <!--                    </v-col>-->
        <!--                </v-row>-->
        <!--                <TextFieldLocale-->
        <!--                    v-model="formData.linkToTripAdvisor[activeLangCode]"-->
        <!--                    :label="`${$t('link_to')} TripAdvisor`"-->
        <!--                    :active-lang-code="activeLangCode"-->
        <!--                    data-cy="link-to-TripAdvisor"-->
        <!--                    class="mb-2"-->
        <!--                    :readonly="isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription"-->
        <!--                />-->
        <!--            </v-col>-->
        <!--        </v-row>-->
        <v-row v-if="false" dense>
            <v-col cols="12" md="2">
                <span class="text-h6 text--secondary">
                    {{ $t('characteristics') }}
                </span>
            </v-col>
            <v-col cols="12" md="4">
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            v-model="formData.villaDescription.buildYear"
                            :label="$t('characteristics_titles.build_year')"
                            type="number"
                            hide-spin-buttons
                            variant="outlined"
                            color="primary"
                            density="compact"
                            data-cy="build-year"
                            :readonly="
                                isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription
                            "
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            v-model="formData.villaDescription.modernizedYear"
                            :label="$t('characteristics_titles.modernized_year')"
                            type="number"
                            hide-spin-buttons
                            variant="outlined"
                            color="primary"
                            density="compact"
                            data-cy="modernized-year"
                            :readonly="
                                isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription
                            "
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            v-model="formData.villaDescription.buildingMaterial"
                            :label="$t('characteristics_titles.building_material')"
                            hide-spin-buttons
                            variant="outlined"
                            color="primary"
                            density="compact"
                            data-cy="building-material"
                            :readonly="
                                isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription
                            "
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            v-model="formData.villaDescription.territoryArea"
                            :label="$t('characteristics_titles.area')"
                            type="number"
                            hide-spin-buttons
                            variant="outlined"
                            color="primary"
                            density="compact"
                            data-cy="territory-area"
                            :readonly="
                                isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription
                            "
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            v-model="formData.villaDescription.houseArea"
                            :label="$t('characteristics_titles.house_area')"
                            type="number"
                            hide-spin-buttons
                            variant="outlined"
                            color="primary"
                            density="compact"
                            data-cy="house-area"
                            :readonly="
                                isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription
                            "
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            v-model="formData.villaDescription.quantityFloors"
                            :label="$t('characteristics_titles.quantity_floors')"
                            type="number"
                            hide-spin-buttons
                            variant="outlined"
                            color="primary"
                            density="compact"
                            data-cy="quantity-floors"
                            :readonly="
                                isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription
                            "
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            v-model="formData.villaDescription.numberOfPeople"
                            :label="$t('characteristics_titles.number_of_people')"
                            type="number"
                            hide-spin-buttons
                            variant="outlined"
                            color="primary"
                            density="compact"
                            data-cy="number-of-people"
                            :readonly="
                                isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription
                            "
                        />
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" md="4">
                <v-row dense>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            v-model="formData.villaDescription.quantityRooms"
                            :label="$t('characteristics_titles.number_of_rooms')"
                            type="number"
                            hide-spin-buttons
                            variant="outlined"
                            color="primary"
                            density="compact"
                            data-cy="number-of-rooms"
                            :readonly="
                                isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription
                            "
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            v-model="formData.villaDescription.quantityBathRooms"
                            :label="$t('characteristics_titles.number_of_bathrooms')"
                            type="number"
                            hide-spin-buttons
                            variant="outlined"
                            color="primary"
                            density="compact"
                            data-cy="number-of-bathrooms"
                            :readonly="
                                isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription
                            "
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            v-model="formData.villaDescription.quantityBars"
                            :label="$t('characteristics_titles.number_of_bars')"
                            type="number"
                            hide-spin-buttons
                            variant="outlined"
                            color="primary"
                            density="compact"
                            data-cy="number-of-bars"
                            :readonly="
                                isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription
                            "
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            v-model="formData.villaDescription.quantitySingleRooms"
                            :label="$t('characteristics_titles.number_of_single_rooms')"
                            type="number"
                            hide-spin-buttons
                            variant="outlined"
                            color="primary"
                            density="compact"
                            data-cy="number-of-single-rooms"
                            :readonly="
                                isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription
                            "
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            v-model="formData.villaDescription.quantityIndoorPools"
                            :label="$t('characteristics_titles.number_of_indoor_pools')"
                            type="number"
                            hide-spin-buttons
                            variant="outlined"
                            color="primary"
                            density="compact"
                            data-cy="number-of-indoor-pools"
                            :readonly="
                                isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription
                            "
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            v-model="formData.villaDescription.quantityRestaurants"
                            :label="$t('characteristics_titles.number_of_restaurant')"
                            type="number"
                            hide-spin-buttons
                            variant="outlined"
                            color="primary"
                            density="compact"
                            data-cy="number-of-restaurant"
                            :readonly="
                                isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription
                            "
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            v-model="formData.villaDescription.quantityDoubleRooms"
                            :label="$t('characteristics_titles.number_of_double_rooms')"
                            type="number"
                            hide-spin-buttons
                            variant="outlined"
                            color="primary"
                            density="compact"
                            data-cy="number-of-double-rooms"
                            :readonly="
                                isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription
                            "
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            v-model="formData.villaDescription.quantityOutdoorPools"
                            :label="$t('characteristics_titles.number_of_outdoor_pools')"
                            type="number"
                            hide-spin-buttons
                            variant="outlined"
                            color="primary"
                            density="compact"
                            data-cy="number-of-outdoor-pools"
                            :readonly="
                                isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription
                            "
                        />
                    </v-col>
                    <v-col cols="12" sm="4">
                        <v-text-field
                            v-model="formData.villaDescription.quantityTripleOrMoreRooms"
                            :label="$t('characteristics_titles.number_of_triple_rooms')"
                            type="number"
                            hide-spin-buttons
                            variant="outlined"
                            color="primary"
                            density="compact"
                            data-cy="number-of-triple-rooms"
                            :readonly="
                                isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription
                            "
                        />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" md="2">
                <div class="d-flex align-center">
                    <span class="text-h6 text--secondary">
                        {{ $t('CO2 Conversion Factors') }}
                    </span>
                    <v-tooltip location="top">
                        <template v-slot:activator="{props}">
                            <v-icon v-bind="props" size="small" class="ml-2" color="grey">
                                mdi-information-outline
                            </v-icon>
                        </template>
                        <span>{{ $t('co2_conversion_factors_tooltip') }}</span>
                    </v-tooltip>
                </div>
            </v-col>
            <v-col cols="12" md="8">
                <v-row dense>
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="formData.conversionFactors.electricityConversion"
                            :label="$t('conversion_factors.electricity_label')"
                            type="number"
                            hide-spin-buttons
                            variant="outlined"
                            color="primary"
                            density="compact"
                            data-cy="electricity-conversion-factor"
                            :rules="electricityValidationRules"
                            validate-on="input blur"
                            :readonly="
                                isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription
                            "
                            @update:model-value="clearApiError('electricityConversion')"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="formData.conversionFactors.naturalGasConversion"
                            :label="$t('conversion_factors.natural_gas_label')"
                            type="number"
                            hide-spin-buttons
                            variant="outlined"
                            color="primary"
                            density="compact"
                            data-cy="natural-gas-conversion-factor"
                            :rules="naturalGasValidationRules"
                            validate-on="input blur"
                            :readonly="
                                isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription
                            "
                            @update:model-value="clearApiError('naturalGasConversion')"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="formData.conversionFactors.oilConversion"
                            :label="$t('conversion_factors.oil_label')"
                            type="number"
                            hide-spin-buttons
                            variant="outlined"
                            color="primary"
                            density="compact"
                            data-cy="oil-conversion-factor"
                            :rules="oilValidationRules"
                            validate-on="input blur"
                            :readonly="
                                isHotelDescriptionMode && !app.$conf.public.account.allowToEditExternalHotelDescription
                            "
                            @update:model-value="clearApiError('oilConversion')"
                        />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-row v-if="sustainabilityClassifications" dense class="mb-6">
            <v-col cols="12" md="2">
                <span class="text-h6 text--secondary">
                    {{ $t('filterTitles.classifications') }}
                </span>
            </v-col>
            <v-col cols="12" md="10">
                <v-row dense>
                    <v-col v-for="(group, index) in sustainabilityClassifications" :key="index" cols="12" sm="3" md="2">
                        <div class="text-subtitle-1 font-weight-medium">{{ $t(`classifications.${index}`) }}:</div>
                        <div v-for="{id, name} in group" :key="id">
                            <v-checkbox
                                v-model="formData.classifications"
                                hide-details
                                :label="name"
                                :value="id"
                                density="compact"
                                :data-cy="id"
                                :readonly="
                                    isHotelDescriptionMode &&
                                    !app.$conf.public.account.allowToEditExternalHotelDescription
                                "
                            />
                        </div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row no-gutters class="gc-4">
            <v-btn
                v-if="!isHotelDescriptionMode || app.$conf.public.account.allowToEditExternalHotelDescription"
                class="save-btn"
                :loading="isLoading"
                :disabled="isLoading"
                @click="save"
            >
                {{ $t('save') }}
            </v-btn>
            <v-btn
                class="cancel-btn"
                data-cy="cancel"
                :disabled="isLoading"
                :to="{name: 'supplierProducts'}"
                variant="text"
            >
                {{ $t('cancel') }}
            </v-btn>
        </v-row>
    </v-form>
</template>
<script setup lang="ts">
    import {initIHotelGeneralDescription} from '~/utils/types/account/products/helpers'

    const isLoading = ref<boolean>(false)
    const formRef = ref(null)

    // Initialize form data with base data and add conversion factors with default values
    const formData = ref({
        ...initIHotelGeneralDescription(),
        conversionFactors: {
            electricityConversion: 0.32,
            naturalGasConversion: 0.2,
            oilConversion: 0.27,
        },
    })

    // API validation errors for conversion factors
    const apiValidationErrors = ref({
        electricityConversion: null,
        naturalGasConversion: null,
        oilConversion: null,
    })

    // Validation rules for conversion factors (must be >= 0.0 + API validation)
    const conversionFactorRules = [
        (value: any) => {
            if (value === null || value === undefined || value === '') return true
            const numValue = parseFloat(value)
            if (isNaN(numValue)) return t('validation.must_be_valid_number')
            if (numValue < 0) return t('validation.value_must_be_greater_than_or_equal_to_zero')
            return true
        },
    ]

    // Specific range validation for electricity (0.26-0.38)
    const electricityRangeRule = (value: any) => {
        if (value === null || value === undefined || value === '') return true
        const numValue = parseFloat(value)
        if (isNaN(numValue)) return true // Let the basic validation handle this
        if (numValue < 0.26 || numValue > 0.38) {
            return t('validation.electricity_conversion_range')
        }
        return true
    }

    // Specific range validation for natural gas (0.20-0.21)
    const naturalGasRangeRule = (value: any) => {
        if (value === null || value === undefined || value === '') return true
        const numValue = parseFloat(value)
        if (isNaN(numValue)) return true // Let the basic validation handle this
        if (numValue < 0.2 || numValue > 0.21) {
            return t('validation.natural_gas_conversion_range')
        }
        return true
    }

    // Specific range validation for oil (0.27-0.28)
    const oilRangeRule = (value: any) => {
        if (value === null || value === undefined || value === '') return true
        const numValue = parseFloat(value)
        if (isNaN(numValue)) return true // Let the basic validation handle this
        if (numValue < 0.27 || numValue > 0.28) {
            return t('validation.oil_conversion_range')
        }
        return true
    }

    // Specific validation rules for each field that include API errors and range validation
    const electricityValidationRules = computed(() => [
        ...conversionFactorRules,
        electricityRangeRule,
        () => apiValidationErrors.value.electricityConversion || true,
    ])

    const naturalGasValidationRules = computed(() => [
        ...conversionFactorRules,
        naturalGasRangeRule,
        () => apiValidationErrors.value.naturalGasConversion || true,
    ])

    const oilValidationRules = computed(() => [
        ...conversionFactorRules,
        oilRangeRule,
        () => apiValidationErrors.value.oilConversion || true,
    ])
    const activeLangCode = ref<string>('en')
    provide('activeLangCode', activeLangCode)
    const isHotelDescriptionMode: boolean = inject('isHotelDescriptionMode', false)
    const hotelDescriptionId: string = inject('hotelDescriptionId', null)
    const classifications = ref(null)

    const sustainabilityClassifications = computed(() => {
        if (!classifications.value) return null
        const result: Record<string, any[]> = {}
        for (const [key, items] of Object.entries(classifications.value) as [string, any[]][]) {
            if (key === 'SUSTAINABILITY_PRACTICES') {
                result[key] = items
            }
        }
        return Object.keys(result).length ? result : null
    })

    const app = useNuxtApp()
    const {t} = useI18n()

    watch(useHotelInfo, async () => {
        await loadData()
        loadHotelClassificationDictionaryInfo()
    })

    onMounted(async () => {
        activeLangCode.value = app.$i18n.locale.value
        if (supplierStore.fullContract?.hotelContentId || isHotelDescriptionMode) await loadData()
        loadHotelClassificationDictionaryInfo()
        EventBus.$on(CHANGE_LOCALE_EVENT, () => loadHotelClassificationDictionaryInfo())
    })

    onBeforeUnmount(() => {
        EventBus.$off(CHANGE_LOCALE_EVENT)
    })

    async function loadData(): Promise<void> {
        const hotelId = isHotelDescriptionMode ? hotelDescriptionId : supplierStore.fullContract.hotelContentId
        try {
            isLoading.value = true
            const res = await app.$api.hotelDescriptionGeneral.get(hotelId, {
                locale: 'all',
            })
            // Preserve the conversionFactors structure when merging API data
            // Handle migration from old default values to new swapped defaults
            let electricityValue =
                res.conversionFactors?.electricityConversion ?? formData.value.conversionFactors.electricityConversion
            let gasValue =
                res.conversionFactors?.naturalGasConversion ?? formData.value.conversionFactors.naturalGasConversion
            let oilValue = res.conversionFactors?.oilConversion ?? formData.value.conversionFactors.oilConversion

            // Migrate old default values to new swapped defaults (case when backend didn't fix defaults provided)
            if (gasValue === 0.27) gasValue = 0.2 // Old gas default -> new gas default
            if (oilValue === 0.2) oilValue = 0.27 // Old oil default -> new oil default

            formData.value = {
                ...formData.value,
                ...res,
                villaDescription: res.villaDescription ?? formData.value.villaDescription,
                conversionFactors: {
                    electricityConversion: electricityValue,
                    naturalGasConversion: gasValue,
                    oilConversion: oilValue,
                },
            }
        } catch (e) {
            app.$toast.error(t('error_message.load_error'))
        } finally {
            isLoading.value = false
        }
    }

    async function loadHotelClassificationDictionaryInfo(): Promise<void> {
        try {
            const res = await app.$api.hotelClassificationDictionaryInfo.get({
                supplierId: supplierStore.hotelInfo?.supplierId || 1,
            })
            const groupedArray = res.reduce((acc: Record<string, any[]>, curr: any) => {
                if (!acc[curr.groupCode]) {
                    acc[curr.groupCode] = []
                }
                acc[curr.groupCode].push(curr)
                return acc
            }, {})
            const desiredOrder = ['LOCATION', 'BUDGET', 'TARGET', 'ARCHITECTURE', 'SUSTAINABILITY_PRACTICES', 'OTHER']
            const keys = Object.keys(groupedArray)
            const sortedKeys = keys?.sort((a: string, b: string) => desiredOrder.indexOf(a) - desiredOrder.indexOf(b))
            const sortedObject: Record<string, any[]> = {}
            sortedKeys.forEach(key => {
                sortedObject[key] = groupedArray[key]?.sort((a: any, b: any) => a.name.localeCompare(b.name))
            })
            classifications.value = sortedObject
        } catch (e) {
            app.$toast.error(t('error_message.load_error'))
        }
    }

    // Clear API validation error for a specific field
    const clearApiError = (fieldName: string): void => {
        if (apiValidationErrors.value[fieldName]) {
            apiValidationErrors.value[fieldName] = null
        }
    }

    // Map API error messages to field names
    const mapApiErrorToField = (errorMessage: string): string | null => {
        if (!errorMessage) return null

        const lowerMessage = errorMessage.toLowerCase()

        // Check for electricity-related errors
        if (lowerMessage.includes('electricity')) return 'electricityConversion'

        // Check for natural gas-related errors
        if (lowerMessage.includes('natural gas') || lowerMessage.includes('naturalgas')) return 'naturalGasConversion'

        // Check for oil-related errors
        if (lowerMessage.includes('oil')) return 'oilConversion'

        return null
    }

    const save = async (): Promise<void> => {
        try {
            isLoading.value = true
            // Clear previous API validation errors
            apiValidationErrors.value = {
                electricityConversion: null,
                naturalGasConversion: null,
                oilConversion: null,
            }

            const hotelId = isHotelDescriptionMode ? hotelDescriptionId : supplierStore.fullContract.hotelContentId
            const payload = {
                ...formData.value,
                villaDescription: formData.value.villaDescription ?? {},
            }
            await app.$api.hotelDescriptionGeneral.put(hotelId, payload)

            app.$toast.success(t('success_message.saved_successfully'))
        } catch (e: any) {
            // Handle API validation errors - check multiple possible locations
            let errors = null
            if (e?.response?.data?.errors && Array.isArray(e.response.data.errors)) {
                errors = e.response.data.errors
            } else if (e?.errors && Array.isArray(e.errors)) {
                errors = e.errors
            }

            if (errors) {
                const validationErrors = errors.filter((error: any) => error.errorType === 'validation')

                if (validationErrors.length > 0) {
                    let hasFieldErrors = false

                    // Map validation errors to fields
                    validationErrors.forEach((error: any) => {
                        const errorMessage = error.message || error.token
                        const fieldName = mapApiErrorToField(errorMessage)

                        if (fieldName) {
                            apiValidationErrors.value[fieldName] = errorMessage
                            hasFieldErrors = true
                        }
                    })

                    // Don't show generic error toast if we have field-specific validation errors
                    if (hasFieldErrors) {
                        // Force form validation to re-run to show the API errors
                        nextTick(() => {
                            if (formRef.value) {
                                formRef.value.validate()
                            }
                        })
                        return
                    }
                }
            }

            // Show generic error for non-validation errors
            app.$toast.error(t('error_message.save_error'))
        } finally {
            isLoading.value = false
        }
    }

    const changeActiveLangCode = (code: string): void => {
        activeLangCode.value = code
    }
</script>

<style scoped>
    /* Smaller font size for input placeholders */
    :deep(.v-field__input input::placeholder) {
        font-size: 0.875rem; /* 14px, smaller than default 16px */
        opacity: 0.6;
    }

    /* For number inputs specifically */
    :deep(.v-field__input input[type='number']::placeholder) {
        font-size: 0.875rem;
        opacity: 0.6;
    }
</style>
